<mat-card class="userWrapper">
    <div class="inner_wrapper">
        <div class="userInfo">
            <!-- *ngIf="userDetails" -->
            <div class="picture">

                <ng-container *ngIf="ImagePathURLU">
                    <ng-container *ngIf="ImagePathURLU.substring(0, 4) == 'http'; else showName">
                        <img src="{{ ImagePathURLU }}" />
                    </ng-container>
                    <ng-template #showName>
                        <span class="shortName">
                            {{ getShortName(FullName) }}</span>
                    </ng-template>
                </ng-container>

                <div class="name" *ngIf="!ImagePathURLU">
                    {{getShortName(FullName)}}
                </div>

                <!-- <img [src]="ImagePathURL" alt="{{getShortName(this.decodedUserData.Name)}}">
                 <div class="name">
                    {{getShortName(this.decodedUserData.Name)}}
                </div>-->
            </div>
            <div class="nameAndsign">
                <h2 class="username">{{ FirstName}} {{LastName}}</h2>

                <div class="otherInfo">
                    <div class="batch">
                        <mat-icon>assignment_ind</mat-icon> {{roles}}
                    </div>
                    <div class="batch">
                        <mat-icon>mail</mat-icon>
                        <p>{{userEmail}}</p>
                    </div>
                </div>


            </div>
        </div>

    </div>
</mat-card>

<mat-card class="tabdetail">
    <mat-tab-group color="primary" mat-align-tabs="center" animationDuration="0ms">
        <mat-tab label="My Profile">
            <div class="tabConainer">
                <div class="tabLabel">
                    My Profile
                </div>
                <div class="picAndForm">
                    <div class="picture" *ngIf="userDetails">

                        <ng-container *ngIf="ImagePathURL">
                            <ng-container *ngIf="ImagePathURL.substring(0, 4) == 'http'; else showName">
                                <img src="{{ ImagePathURL }}" />
                            </ng-container>

                            <ng-template #showName>
                                <span class="shortName">
                                    {{ getShortName(FullName) }}</span>
                            </ng-template>
                        </ng-container>

                        <div class="name" *ngIf="!ImagePathURL">
                            {{ getShortName(FullName) }}
                        </div>

                        <!-- <img [src]="ImagePathURL" alt="{{getShortName(this.decodedUserData.Name)}}">
                        <div class="name">
                            {{getShortName(this.decodedUserData.Name)}}
                        </div>  -->

                        <div class="upload">
                            <mat-icon>add_photo_alternate</mat-icon>
                            <input type="file" placeholder="Choose file" (change)="onSelectFile($event)">
                        </div>

                    </div>

                    

                    <div class="userForm">
                        

                        <form [formGroup]="updateUserProfileform">
                            <button mat-icon-button color="primary" (click)="linkCopied()" [cdkCopyToClipboard]="userIdShow">
                                <mat-icon>link</mat-icon> UserId
                              </button>
                              
                            <div class="divideCol">
                                <div class="blk">
                                    <mat-form-field appearance="fill">
                                        <mat-label>First Name</mat-label>
                                        <input matInput placeholder="Add First Name" maxlength="30"
                                            formControlName="firstname" [(ngModel)]="updateUserProfile.FirstName"
                                            (keypress)="allowAlphabetOnly($event)" required>
                                        <mat-error>
                                            {{ titleAlert }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="blk">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Last Name</mat-label>
                                        <input matInput placeholder="Add Last Name" maxlength="30"
                                            formControlName="lastname" [(ngModel)]="updateUserProfile.LastName"
                                            (keypress)="allowAlphabetOnly($event)" required>
                                        <mat-error>
                                            {{ titleAlert }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="divideCol">
                                <mat-form-field appearance="fill">
                                    <mat-label>Enter Email</mat-label>
                                    <input matInput placeholder="Add Email" maxlength="50" formControlName="email"
                                        [(ngModel)]="updateUserProfile.Email" readonly>
                                </mat-form-field>
                            </div>
                            <div class="divideCol">
                                <mat-form-field appearance="fill">
                                    <mat-label>Enter Phone</mat-label>
                                    <span matPrefix>+1 &nbsp;</span>
                                    <input matInput placeholder="Add Phone" (keypress)="numberOnly($event)"
                                        formControlName="phone" [(ngModel)]="updateUserProfile.Phone"
                                        mask="(000) 000-0000">
                                </mat-form-field>
                            </div>
                            <div class="divideCol">
                                <mat-form-field appearance="fill">
                                    <mat-label>Enter Address</mat-label>
                                    <input matInput placeholder="Add Address" maxlength="100" formControlName="address"
                                        [(ngModel)]="updateUserProfile.Address">
                                </mat-form-field>
                            </div>
                            <div class="divideCol">
                                <mat-form-field appearance="fill">
                                    <mat-label>Select DOB</mat-label>
                                    <input matInput placeholder="Add DOB" [matDatepicker]="basicDatepicker"
                                        [(ngModel)]="updateUserProfile.DOB" formControlName="dob" readonly />
                                    <mat-datepicker-toggle matSuffix [for]="basicDatepicker"></mat-datepicker-toggle>
                                    <mat-datepicker #basicDatepicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="divideCol">
                                <mat-form-field appearance="fill">
                                    <mat-label>Enter Title</mat-label>
                                    <input matInput placeholder="Add Title" maxlength="100" formControlName="title"
                                        [(ngModel)]="updateUserProfile.Title">
                                </mat-form-field>
                            </div>
                        </form>
                        <div class="divideCol">
                            <mat-form-field appearance="fill">
                                <mat-label>Enter Time Zone</mat-label>
                                <input matInput placeholder="Add Time Zone" [(ngModel)]="TimeZone" readonly>
                            </mat-form-field>
                        </div>

                        
                        <div class="divideCol">
                            <mat-form-field appearance="fill">
                                <mat-label>User Id</mat-label>
                                <input matInput [(ngModel)]="userIdShow" readonly>
                            </mat-form-field>
                        </div>

                        <div class="divideCol actbtn">
                            <!-- <button mat-flat-button color="basic">Cancel</button> -->
                            <button mat-flat-button color="primary"
                                [disabled]="updateUserProfileform.invalid || !updateUserProfileform.dirty"
                                (click)="SaveUserDetails(updateUserProfileform.value)">Save
                                <mat-icon *ngIf="spinner"><mat-spinner diameter="20">
                                    </mat-spinner></mat-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Signature" *ngIf="showLocalPanel">
            <div class="tabConainer">
                <div class="tabLabel">
                    Signature
                </div>


                <div class="radOpts">
                    <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="signOpt">
                        <mat-radio-button value="draw">Draw</mat-radio-button>
                        <mat-radio-button value="upload">Upload</mat-radio-button>
                        <mat-radio-button value="type">Type In</mat-radio-button>
                    </mat-radio-group>
                </div>



                <div class="allSCont">
                    <ng-container *ngIf="signOpt == 'upload'">
                        <div class="uploadholder">
                            <mat-icon>note_add</mat-icon>
                            <p>Drop your signature here or click here to upload</p>
                            <span>File extension should be .png</span>
                            <input type="file" />
                        </div>
                    </ng-container>

                    <ng-container *ngIf="signOpt == 'draw'">
                        <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                            (onEndEvent)="drawComplete()"></signature-pad>
                    </ng-container>

                    <ng-container *ngIf="signOpt == 'type'">
                        <div class="divideCol">
                            <div class="left blk">
                                <mat-form-field>
                                    <mat-label>Enter Name</mat-label>
                                    <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName">
                                </mat-form-field>
                            </div>
                            <div class="right blk">
                                <mat-form-field appearance="fill">
                                    <mat-label>Select font family</mat-label>
                                    <mat-select [(value)]="selected">
                                        <mat-option *ngFor="let fam of family; index as i"
                                            value="{{fam.font}}">{{fam.font}}</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="allSign">
                            <div class="signlook" [ngStyle]="{'font-family': selected}">
                                {{signName}}
                            </div>
                        </div>
                    </ng-container>
                </div>
                <div class="actbtn mt-10">
                    <button mat-flat-button color="primary">Save</button>
                </div>
            </div>

            <div class="tabConainer">
                <table>
                    <tr>
                        <th><span>Mark Active</span></th>
                        <th><span>Signature</span></th>
                        <th><span>Initials</span></th>
                        <th><span>Action</span></th>
                    </tr>
                    <tr>
                        <td>

                            <mat-radio-group name="active" color="primary">
                                <mat-radio-button value="1"></mat-radio-button>
                            </mat-radio-group>


                        </td>
                        <td>

                            <div class="sig-cell">
                                <div class="sig-chrome">
                                    <span class="sig-chrome-title-top ng-scope" translate="flowtrics by:">Powered by:
                                        flowtrics</span>
                                    <div class="sig-container">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/George_M_Dallas-2signature.svg/1280px-George_M_Dallas-2signature.svg.png"
                                            class="sig ng-scope" alt="surender kumar">
                                    </div>
                                    <span class="sig-chrome-title-bottom ng-binding">A8046DAACAEE4DE...</span>
                                </div>
                            </div>


                        </td>
                        <td>
                            <div class="sig-cell">
                                <div class="sig-chrome">
                                    <span class="sig-chrome-title-top ng-scope" translate="flowtrics by:">Powered by:
                                        flowtrics</span>
                                    <div class="sig-container">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/George_M_Dallas-2signature.svg/1280px-George_M_Dallas-2signature.svg.png"
                                            class="sig ng-scope" alt="surender kumar">
                                    </div>
                                    <span class="sig-chrome-title-bottom ng-binding">A8046DAACAEE4DE...</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <button mat-icon-button color="basic">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button color="basic">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td>

                            <mat-radio-group name="active" color="primary">
                                <mat-radio-button value="1"></mat-radio-button>
                            </mat-radio-group>


                        </td>

                        <td>

                            <div class="sig-cell">
                                <div class="sig-chrome">
                                    <span class="sig-chrome-title-top ng-scope" translate="flowtrics by:">Powered by:
                                        flowtrics</span>
                                    <div class="sig-container">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/George_M_Dallas-2signature.svg/1280px-George_M_Dallas-2signature.svg.png"
                                            class="sig ng-scope" alt="surender kumar">
                                    </div>
                                    <span class="sig-chrome-title-bottom ng-binding">A8046DAACAEE4DE...</span>
                                </div>
                            </div>


                        </td>
                        <td>
                            <div class="sig-cell">
                                <div class="sig-chrome">
                                    <span class="sig-chrome-title-top ng-scope" translate="flowtrics by:">Powered by:
                                        flowtrics</span>
                                    <div class="sig-container">
                                        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c7/George_M_Dallas-2signature.svg/1280px-George_M_Dallas-2signature.svg.png"
                                            class="sig ng-scope" alt="surender kumar">
                                    </div>
                                    <span class="sig-chrome-title-bottom ng-binding">A8046DAACAEE4DE...</span>
                                </div>
                            </div>
                        </td>
                        <td>
                            <button mat-icon-button color="basic">
                                <mat-icon>edit</mat-icon>
                            </button>
                            <button mat-icon-button color="basic">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </td>
                    </tr>
                </table>

                <div class="addSignature">
                    <button mat-flat-button color="primary" (click)="OpenSignPopup(AddSignature)">Add New</button>
                </div>


            </div>

        </mat-tab>

        <mat-tab label="PIN" *ngIf="showLocalPanel">

            <div class="tabConainer">
                <div class="tabLabel">
                    Pin - Set up your pin code.
                </div>

                <div class="createPin" *ngIf="!addPin">
                    <button mat-stroked-button color="primary" (click)="createPin()">Create Pin</button>
                </div>

                <h2 class="pinAdded" *ngIf="pinAdded">****</h2>

                <div class="createPin" *ngIf="pinAdded">
                    <button mat-stroked-button color="primary" (click)="forgotPin()">Forgot Pin?</button>
                </div>

                <div class="userForm pinform" *ngIf="addEditPin">
                    <div class="divideCol">
                        <mat-form-field appearance="fill">
                            <mat-label>Add Pin</mat-label>
                            <input matInput placeholder="Add Pin">
                        </mat-form-field>
                    </div>
                    <div class="divideCol">
                        <mat-form-field appearance="fill">
                            <mat-label>Confirm Pin</mat-label>
                            <input matInput placeholder="Confirm Pin">
                        </mat-form-field>
                    </div>
                    <div class="divideCol actbtn">
                        <button mat-flat-button color="basic">Cancel</button>
                        <button mat-flat-button color="primary" (click)="savePin()">Create</button>

                    </div>
                </div>

            </div>

        </mat-tab>


        <mat-tab label="User Preference">

            <div class="tabConainer">
                <div class="tabLabel">
                    User Preference
                </div>
                <div class="toggleNoti">
                    <mat-slide-toggle color="primary" [checked]="multiFactorAuth" (change)="Update2FactorAuth($event)">
                        2 Factor Authentication
                    </mat-slide-toggle>

                    <!-- <mat-slide-toggle color="primary" >Email Notification</mat-slide-toggle>
                    <mat-slide-toggle class="all" color="primary" >Turn on all notifications</mat-slide-toggle> -->
                </div>

                <!-- <div class="allnoti">
                    <mat-checkbox color="primary" >When core is added.</mat-checkbox>
                    <mat-checkbox color="primary">When core is deleted.</mat-checkbox>

                    <mat-checkbox color="primary" >When contact is added.</mat-checkbox>
                    <mat-checkbox color="primary">When contact is deleted.</mat-checkbox>

                    <mat-checkbox color="primary" >When company is added.</mat-checkbox>
                    <mat-checkbox color="primary">When company is deleted.</mat-checkbox>

                    <mat-checkbox color="primary" >When document is added.</mat-checkbox>
                    <mat-checkbox color="primary">When document is deleted.</mat-checkbox>
                    <mat-checkbox color="primary">When document is updated.</mat-checkbox>

                    <mat-checkbox color="primary">When someone message me.</mat-checkbox>
                    <mat-checkbox color="primary">When someone mentions me.</mat-checkbox>
                </div> -->

            </div>

        </mat-tab>

        <mat-tab label="Integration">

            <div class="oneblk">

                <mat-card class="impBlock" *ngFor="let app of thirdPartyApplicationList">
                    <img src="{{app.apiLogo}}" (click)="showDetailLogo(app)" alt="">


                    <div class="detail">
                        <span (click)="showDetail(app)">{{app.thirdPartyApiName}}</span>
                        <p (click)="showDetail(app)">{{app.apiDescription}}</p>
                        <div class="actions">
                            <button mat-icon-button color="basic" (click)="openDialogIntegration(integration,app)"
                                matTooltip="Add/Edit API Credentials"
                                matTooltipClass="tooltip"><mat-icon>add</mat-icon></button>

                        </div>

                    </div>

                </mat-card>

            </div>

            <!-- <div class="tabConainer">
                <div class="tabLabel">
                    Integration
                </div>
              
                <button  mat-icon-button color="basic" (click)="openDialogIntegration(integration)" class="ml-auto" matTooltip="Add Integration" matTooltipClass="tooltip"><mat-icon>edit_square</mat-icon></button>
              
            </div> -->

        </mat-tab>

        <mat-tab label="Notification Preference">

            <!-- <div class="tabConainer">
                <div class="tabLabel">
                    Notification Preference
                </div>

                <div class="toggleNoti">
                    <mat-slide-toggle class="all" color="primary" [(ngModel)]="allNotifications" (change)="onToggleAll()">Turn on all notifications</mat-slide-toggle>
                </div>


                <div class="toggleNoti">
                    <mat-slide-toggle color="primary" [(ngModel)]="emailNotification" (change)="onToggleEmail()">Email Notification</mat-slide-toggle>
                </div>

                <div class="toggleNoti">
                    <mat-slide-toggle color="primary" [(ngModel)]="textNotification" (change)="onToggleText()">Text Notification</mat-slide-toggle>
                </div>

                <div class="toggleNoti">
                    <mat-slide-toggle color="primary" [(ngModel)]="inAppNotification" (change)="onToggleInApp()">Inapp Notification</mat-slide-toggle>
                </div>

            </div> -->

            <div class="tabNotification">
                <table  border-spacing="0">
                    <tr>
                        <th>Module Name</th>
                        <th>Email Notification</th>
                        <th>Text Notification</th>
                        <th>Inapp Notification</th>
                    </tr>
                    <tr>
                        <td>Core</td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                    </tr>
                    <tr>
                        <td>Contact</td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                    </tr>
                    <tr>
                        <td>Company</td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                    </tr>
                    <tr>
                        <td>Form</td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                        <td>  <mat-checkbox color="primary" ></mat-checkbox></td>
                    </tr>
                </table>
            </div>

        </mat-tab>

        <mat-tab label="Password & Security">

            <div class="tabConainer">
                <div class="tabLabel">
                    Change password
                </div>
                <form [formGroup]="updatePasswordForm">
                    <div class="userForm">
                        <div class="divideCol" *ngIf="!isMasterPasswordLogin">
                            <mat-form-field appearance="fill">
                                <mat-label>Current Password</mat-label>
                                <!-- <input matInput placeholder="Current Password" formControlName="currentPassword" maxlength="30"> -->

                                <input matInput [type]="hidecurrent ? 'password' : 'text'"
                                    placeholder="Current Password" formControlName="currentPassword" maxlength="30"
                                    autocomplete="off">
                                <mat-error class="errorpass">
                                    Password of at least eight characters with one uppercase, one special character,
                                    lowercase letter and one number
                                </mat-error>
                                <mat-icon matSuffix (click)="hidecurrent = !hidecurrent"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hidecurrent">{{hidecurrent
                                    ? 'visibility_off' : 'visibility'}}</mat-icon>

                            </mat-form-field>
                        </div>
                        <div class="divideCol forPassword">
                            <mat-form-field appearance="fill">
                                <mat-label>New Password</mat-label>
                                <input matInput [type]="hidenew ? 'password' : 'text'" placeholder="Enter new password"
                                    formControlName="newPassword" maxlength="30" (keyup)="Passwords()"
                                    autocomplete="off">
                                <mat-icon matSuffix (click)="hidenew = !hidenew" [attr.aria-label]="'Hide password'"
                                    [attr.aria-pressed]="hidenew">{{hidenew ? 'visibility_off' :
                                    'visibility'}}</mat-icon>
                                <mat-hint class="errorpass">Choose a password of at least eight characters,
                                    one uppercase, one special character, lowercase letter and one number
                                </mat-hint>
                                <mat-error class="errorpass">
                                    Password of at least eight characters with one uppercase, one special character,
                                    lowercase letter and one number
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="divideCol ">
                            <mat-form-field appearance="fill" fxFlex>
                                <mat-label>Confirm password</mat-label>
                                <input matInput [type]="hideconfirm ? 'password' : 'text'"
                                    placeholder="Re-enter confirm password" maxlength="30" (keyup)="matchPassword()"
                                    formControlName="confirmPassword" autocomplete="off">
                                <span matSuffix (click)="hideconfirm = !hideconfirm" [attr.aria-label]="'Hide password'"
                                    [attr.aria-pressed]="hideconfirm">
                                    <mat-icon>{{hideconfirm ? 'visibility_off' : 'visibility'}}</mat-icon>
                                </span>
                                <mat-error class="errorpass">
                                    Password does not match
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="divideCol actbtn">
                            <!-- <button mat-flat-button color="basic" >Cancel</button> -->
                            <button mat-flat-button color="primary" (click)="updatePassword(updatePasswordForm.value)"
                                [disabled]="!UpdatePassword">Update</button>

                        </div>
                    </div>
                </form>

                <!-- <div class="tabLabel">
                    Security
                </div>
                <div class="">
                    <div class="tabSubLabel">
                        Two way authentication method
                    </div>
                    <mat-radio-group class="factor" color="primary"  >             
                    <mat-radio-button class="example-radio-button"  name="auth" value="1">
                        Through email
                        <p><span>mattxxxxxxxxxxxxgmail.com </span><button mat-stroked-button color="primary" >Change</button></p>
                    </mat-radio-button>
                    <mat-radio-button class="example-radio-button" name="auth"  value="2">
                        Through SMS
                        <p><span>985xxxxxxxxxxxx25 </span><button mat-stroked-button  color="primary">Change</button></p>
                    </mat-radio-button>
                    
                    <mat-radio-button class="example-radio-button" name="auth"  value="3">
                        Both
                    </mat-radio-button>
                    <mat-radio-button class="example-radio-button" name="auth"  value="4">
                        Turn off 2 Factor Identification
                    </mat-radio-button>
                    </mat-radio-group>

                    <div class="divideCol">
                        <button class="save" mat-flat-button color="primary" >Save</button>
                    </div>

                </div> -->
            </div>
        </mat-tab>
    </mat-tab-group>

</mat-card>




<ng-template #AddSignature>
    <h2 mat-dialog-title>
        <span class="groupIcon">
            <mat-icon>create</mat-icon>
        </span>
        Add Signature
        <button mat-icon-button>
            <mat-icon>close</mat-icon>
        </button>
    </h2>

    <mat-dialog-content class="mat-typography">
        <div class="signHolder">

            <mat-tab-group animationDuration="0ms">

                <mat-tab label="Draw">

                    <div class="allSCont">
                        <div class="signIn">
                            <div class="sign">
                                <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()"
                                    (onEndEvent)="drawComplete()"></signature-pad>
                                <div class="signopt">
                                    <p>Draw Signature</p>
                                    <a href="javascript:void(0)">Clear</a>
                                </div>
                            </div>
                            <div class="intial">
                                <signature-pad [options]="signaturePadOptions1" (onBeginEvent)="drawStart()"
                                    (onEndEvent)="drawComplete()"></signature-pad>
                                <div class="signopt">
                                    <p>Draw Initials</p>
                                    <a href="javascript:void(0)">Clear</a>
                                </div>
                            </div>
                        </div>
                    </div>


                </mat-tab>

                <mat-tab label="Upload">

                    <div class="allSCont">
                        <div class="signIn">
                            <div class="sign">
                                <div class="uploadholder">
                                    <mat-icon>note_add</mat-icon>
                                    <p>Upload Signature</p>
                                    <span>File extension should be .png</span>
                                    <!-- <p>{{filenameForSign}}</p> -->
                                    <input type="file" class="form-control" accept="image/*" placeholder="Add file">
                                </div>
                                <p>Accepted file formats: GIF, JPG, PNG, BMP. Max file size 200KB.</p>
                            </div>

                            <div class="intial">
                                <div class="uploadholder">
                                    <mat-icon>note_add</mat-icon>
                                    <p>Upload Initials</p>
                                    <span>File extension should be .png</span>
                                    <!-- <p>{{filenameForSign}}</p> -->
                                    <input type="file" class="form-control" accept="image/*" placeholder="Add file">
                                </div>
                            </div>
                        </div>
                    </div>




                </mat-tab>

                <mat-tab label="Type In">
                    <div class="divideCol">
                        <div class="left blk sininiti">
                            <mat-form-field>
                                <mat-label>Full Name</mat-label>
                                <input matInput required placeholder="Enter name" value="{{FullName}}"
                                    [(ngModel)]="FullName">
                            </mat-form-field>
                            <mat-form-field>
                                <mat-label>Initials Name</mat-label>
                                <input matInput required placeholder="Enter Initials" value="SK"
                                    [(ngModel)]="signNameInitial">
                            </mat-form-field>
                        </div>
                        <div class="right blk">
                            <mat-form-field appearance="fill">
                                <mat-label>Select font family</mat-label>
                                <mat-select [(value)]="selected"
                                    (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                                    <mat-option *ngFor="let fam of family; index as i"
                                        value="{{fam.font}}">{{fam.font}}</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>


                    <div class="signIn">
                        <div class="sign">
                            <div class="allSign">
                                <div class="signlook" [ngStyle]="{'font-family': selected}">
                                    {{signName}}
                                </div>
                            </div>
                            <div class="signopt">
                                <p>Signature</p>
                                <!-- <a href="javascript:void(0)">Clear</a> -->
                            </div>
                        </div>
                        <div class="intial">
                            <div class="allSign">
                                <div class="signlook" [ngStyle]="{'font-family': selected}">
                                    {{signNameInitial}}
                                </div>
                            </div>
                            <div class="signopt">
                                <p>Initials</p>
                                <!-- <a href="javascript:void(0)">Clear</a> -->
                            </div>
                        </div>
                    </div>



                </mat-tab>

            </mat-tab-group>

            <!-- <div class="old">
            <div class="radOpts" >
                <mat-radio-group aria-label="Select an option" color="primary" [(ngModel)]="signOpt"   >
                    <mat-radio-button value="draw">Draw</mat-radio-button>
                    <mat-radio-button value="upload">Upload</mat-radio-button>
                    <mat-radio-button value="type">Type In</mat-radio-button>
                  </mat-radio-group>
            </div>
           
      
      
              <div class="allSCont">
                <ng-container *ngIf="signOpt == 'upload'">
                  <div class="uploadholder">
                    <mat-icon>note_add</mat-icon>
                    <p *ngIf="filenameForSign == '' ">Drop your signature here or click here to upload</p>
                    <span  *ngIf="filenameForSign == '' ">File extension should be .png</span>
                    <p>{{filenameForSign}}</p>
                    <input type="file" class="form-control" accept="image/*" 
                    (change)="onSelectSignImage($event,'','')" placeholder="Add file">
                  </div>
                </ng-container>
                
                  <ng-container *ngIf="signOpt == 'draw'">              
                        <div class="signIn">
                            <div class="sign">
                                <signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>                
                                <p>Signature</p>
                            </div>
                            <div class="intial">
                                <signature-pad [options]="signaturePadOptions1" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>                
                                <p>Initials</p>
                            </div>
                        </div>
                  </ng-container>
                
                  <ng-container *ngIf="signOpt == 'type'">
                    <div class="divideCol">
                      <div class="left blk">
                        <mat-form-field >
                          <mat-label>Enter Name</mat-label>
                          <input matInput required placeholder="Enter name" value="" [(ngModel)]="signName" (ngModelChange)="signOrInitialTextChanges($event)">
                        </mat-form-field>
                      </div>
                      <div class="right blk">
                        <mat-form-field appearance="fill">
                            <mat-label>Select font family</mat-label>
                            <mat-select [(value)]="selected" (selectionChange)="setSignInitialFontFamilyChange($event.value)">
                              <mat-option *ngFor="let fam of family; index as i" value="{{fam.font}}" >{{fam.font}}</mat-option>
                            </mat-select>
                          </mat-form-field>
                      </div>
                    </div>
                    <div class="allSign">
                      <div class="signlook" [ngStyle]="{'font-family': selected}" >
                        {{signName}}
                      </div>
                    </div>
                  </ng-container>
               </div> 
         </div> -->
        </div>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button>Cancel</button>
        <span>
            <button mat-stroked-button color="primary">Clear</button>
            <button mat-flat-button color="primary">Save</button>
        </span>
    </mat-dialog-actions>
</ng-template>




<ng-template #integration>
    <form [formGroup]="formDialog">
        <h2 mat-dialog-title>
            Add Integration
            <button mat-icon-button (click)="close()">
                <mat-icon>close</mat-icon>
            </button>
        </h2>

        <mat-dialog-content class="mat-typography">

            <mat-form-field class="example-full-width">
                <mat-label>Add Grant Type</mat-label>
                <input matInput placeholder="Enter grant type" formControlName="grantType" />
                <!-- <mat-error
          *ngIf="formDialog.get('applicationurllogo').invalid &&
            (formDialog.get('applicationurllogo').dirty ||
            formDialog.get('applicationurllogo').touched)">
          <span>This field is mandatory.</span>
        </mat-error> -->

            </mat-form-field>


            <mat-form-field class="example-full-width">
                <mat-label>Add clientID</mat-label>
                <input matInput placeholder="Enter client ID" formControlName="clientID" />
                <!-- <mat-error
          *ngIf="formDialog.get('authenticationurl').invalid &&
            (formDialog.get('authenticationurl').dirty ||
            formDialog.get('authenticationurl').touched)">
          <span>This field is mandatory.</span>
        </mat-error> -->

            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Add Client Secret</mat-label>
                <input matInput placeholder="Enter client secret" formControlName="clientSecret" />

                <!-- <mat-error
          *ngIf="formDialog.get('apiDocumentationUrl').invalid &&
            (formDialog.get('apiDocumentationUrl').dirty ||
            formDialog.get('apiDocumentationUrl').touched)">
          <span>This field is mandatory.</span>
        </mat-error> -->

            </mat-form-field>


            <mat-form-field class="example-full-width">
                <mat-label> Username</mat-label>
                <input matInput placeholder="Enter username" formControlName="username" />

                <!-- <mat-error
            *ngIf="formDialog.get('apiDocumentationUrl').invalid &&
              (formDialog.get('apiDocumentationUrl').dirty ||
              formDialog.get('apiDocumentationUrl').touched)">
            <span>This field is mandatory.</span>
          </mat-error> -->

            </mat-form-field>


            <mat-form-field class="example-full-width">
                <mat-label> Password</mat-label>
                <input matInput placeholder="Enter password" formControlName="password" />

                <!-- <mat-error
            *ngIf="formDialog.get('apiDocumentationUrl').invalid &&
              (formDialog.get('apiDocumentationUrl').dirty ||
              formDialog.get('apiDocumentationUrl').touched)">
            <span>This field is mandatory.</span>
          </mat-error> -->

            </mat-form-field>

        </mat-dialog-content>

        <mat-dialog-actions class="dialog-actions">
            <button mat-button (click)="close()">Cancel</button>
            <button mat-flat-button color="primary" [disabled]="formDialog.invalid || !formDialog.dirty"
                (click)="AddUpdateIntegration(formDialog.value)">
                Add
                <mat-icon *ngIf="spinnerIntegration"><mat-spinner diameter="20">
                    </mat-spinner></mat-icon>
            </button>
        </mat-dialog-actions>

    </form>
</ng-template>
<app-loader></app-loader>